import React, { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { createTask, createTasks } from 'actions/tasks';

import TaskListItem from 'components/TaskListItem';

const EMPTY_OBJECT = {};

const CreateListTaskItem = ({ autoFocus, taskProps = EMPTY_OBJECT, onBeforeCreate, onCreate }) => {
    const { t } = useTranslation('task');
    const taskCtrl = useRef(null);

    const handleTaskCreate = useCallback(async (taskId, name) => {
        try {
            let updatedTaskProps;

            if (onBeforeCreate) {
                updatedTaskProps = await onBeforeCreate(taskProps);
                if (!updatedTaskProps) {
                    return;
                }
            }

            taskCtrl.current.reset();

            await createTask({
                name,
                ...(updatedTaskProps || taskProps)
            })
            onCreate && onCreate()

            setTimeout(() => {
                if (taskCtrl.current) {
                    taskCtrl.current.beginEdit();
                }
            }, 0);
        } catch (e) {}
    }, [taskProps, onBeforeCreate, onCreate, taskCtrl]);

    const handleTasksPaste = useCallback(async (event, value) => {
        const entries = value.split('\n').filter(taskName => Boolean((taskName || '').trim()) && taskName !== '\n\u200B' && taskName !== decodeURIComponent('%E2%80%8B'));

        if (entries.length > 1) {
            let updatedTaskProps;

            if (onBeforeCreate) {
                updatedTaskProps = await onBeforeCreate(taskProps);
                if (!updatedTaskProps) {
                    return;
                }
            }

            createTasks(entries.map(name => ({
                name: (name || '').trim(),
                ...(updatedTaskProps || taskProps)
            }))).then(() => {
                onCreate && onCreate();
            });

            return true;
        }

        return false;
    }, [taskProps, onBeforeCreate, onCreate]);

    return (
        <TaskListItem
            key="new"
            new={true}
            editing={true}
            canEdit={true}
            autoFocus={autoFocus}
            autoFocusDelay={300}
            onNameChange={handleTaskCreate}
            onNamePaste={handleTasksPaste}
            namePlaceholder={ `${t('Add a new task')}...` }
            provideController={taskCtrl}
        />
    );
}

export default CreateListTaskItem;
